import { EnvVarMap, PartialEnvVarMap } from "./types/envVar";
import {
  getEnvironmentName,
  Environments,
} from "lib/environment/environment-finder";

import defaultEnvVars from "./environments/default";
import developmentEnvVars from "./environments/development";
import stagingEnvVars from "./environments/staging";
import productionEnvVars from "./environments/production";
import tourEnvVars from "./environments/tour";
import tour2EnvVars from "./environments/tour2";

let envVariablesInMemory: EnvVarMap;

// Add to this map for env-specific overrides
const envVarsOverridesMap: Partial<Record<Environments, PartialEnvVarMap>> = {
  production: productionEnvVars,
  tour: tourEnvVars,
  tour2: tour2EnvVars,
  development: developmentEnvVars,
  staging: stagingEnvVars,
};

const loadEnvVariables = (envName: Environments) => {
  const overrides: PartialEnvVarMap | undefined = envVarsOverridesMap[envName];

  envVariablesInMemory = {
    ...defaultEnvVars,
    ...overrides,
  };
};

const getEnvVariables = (): EnvVarMap => {
  const envName = getEnvironmentName();

  if (!envVariablesInMemory) loadEnvVariables(envName);

  // Shallow clone. Modify this if env variables are ever updated to include nested objects
  return { ...envVariablesInMemory };
};

export default getEnvVariables;
